import { cn } from '@/lib/utils'
import {
  SelectContent,
  SelectGroup,
  SelectItem,
  Select as SelectShadCn,
  SelectTrigger,
  SelectValue
} from '@/ui/Shadcn/select'
import { memo } from 'react'

interface SelectProps extends React.ComponentProps<typeof SelectShadCn> {
  options: { value: string; label: string }[]
  label?: string
  description?: string
  id?: string
  size?: 's' | 'default'
}

export function Select({
  options,
  description,
  size = 'default',
  ...props
}: SelectProps) {
  const { required, name, label } = props || {}

  const placeholder =
    options.find((option) => !option.value)?.label ||
    label ||
    'Select an option'

  const filteredOptions = options.filter((option) => option.value)

  return (
    <div className="relative flex flex-col">
      <SelectShadCn name={name} {...props}>
        <SelectTrigger
          className={cn(
            'px-md py-xs textstyle-md-regular min-h-14 w-full border-none! bg-neutral-200 text-neutral-600',
            size === 's' && 'min-h-10'
          )}
        >
          <SelectValue placeholder={placeholder + (required ? '*' : '')} />
        </SelectTrigger>
        <SelectContent className="border-none!">
          <SelectGroup className="gap-lg">
            {filteredOptions.map((option) => (
              <SelectItem
                key={option.value || option.label}
                value={option.value}
                className="textstyle-md-regular py-xs text-neutral-600 focus:bg-neutral-200"
              >
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </SelectShadCn>
      {description && <p className="text-sm text-gray-500">{description}</p>}
    </div>
  )
}

export default memo(Select)
